export default __webpack_public_path__ + "static/media/wave.69fc232b.png";